import { render, staticRenderFns } from "./ConflictList.vue?vue&type=template&id=5083d95b&scoped=true&"
import script from "./ConflictList.vue?vue&type=script&lang=js&"
export * from "./ConflictList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5083d95b",
  null
  
)

export default component.exports